import GrandIdSettingModal from './grandid-setting-modal-container'
export default GrandIdSettingModal
